export const objectMap = (obj: any, fn: any) =>
  Object.fromEntries(Object.entries(obj).map(([k, v], i) => [k, fn(v, k, i)]));

export const isObjectEmpty = (obj: any) =>
  !obj || Object.keys(obj)?.length === 0;

export const cleanParams = (
  // eslint-disable-next-line no-undef
  params: Record<string, any>
  // eslint-disable-next-line no-undef
): Record<string, any> => {
  return Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) =>
        value !== undefined &&
        value !== null &&
        !(typeof value === 'string' && value.trim() === '') &&
        !(Array.isArray(value) && value.length === 0)
    )
  );
};

export const sanitizePayloadData = (data: any) => {
  return Object.fromEntries(
    // eslint-disable-next-line no-unused-vars
    Object.entries(data).filter(([_, value]) => {
      return value !== '' && value !== null && value !== undefined;
    })
  );
};

export const cleanUrlParams = (params: any) => {
  const urlParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;

    if (Array.isArray(value)) {
      if (value.length > 0) {
        urlParams.set(key, value.join(','));
      }
    } else {
      urlParams.set(key, String(value));
    }
  });

  return urlParams;
};
